






























import Vue from 'vue'
import { downloadFile } from '@/utils'

export default Vue.extend({
  name: 'ImportButton',
  props: ['filename', 'downloadFn', 'importFn', 'type', 'productId', 'customParams', 'refresh', 'newResFlag'],
  data() {
    return {
      visible: false,
      loading: {
        submit: false,
        download: false
      },
      fileList: [],
      fixedEdition: false// 导入时是否定版
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (!val) {
          this.fileList = []
        }
      }
    }
  },
  methods: {
    openModal() {
      this.visible = true
    },
    async download() {
      this.loading.download = true
      try {
        const res = await this.downloadFn()
        downloadFile(res, this.filename)
      } finally {
        this.loading.download = false
      }
    },
    async submit() {
      const [file] = this.fileList
      this.loading.submit = true
      try {
        const formData = new FormData()
        formData.append('file', file, file.name)
        let res
        if (this.type && this.type === 'process') {
          formData.append('productId', this.productId)
          res = await this.importFn(formData)
          this.$message.info(this.$t(res.data.data.importResult))
          if (res.data.data.failInfo) { // 失败提示
            this.$message.info(this.$t(res.data.data.failInfo))
          } else { // 成功则刷新工艺版本
            this.$emit('refresh')
          }
        } else {
          if (this.customParams) { // 自定义导入参数
            res = await this.importFn(file, this.fixedEdition)
          } else {
            res = await this.importFn(formData)
          }
          if (this.newResFlag) { // 新返回形式：无论导入成功与否都返回文件流
            const reader = new FileReader()
            reader.readAsText(res)
            reader.onload = () => {
              // console.log('FileReader', reader.result)
              if (reader.result) { // 导入发生错误,下载错误提示文件
                this.$message.info(this.$t('import_err_tip'))
                downloadFile(res, 'errorMsg.xlsx')
              } else { // 导入成功
                if (this.refresh) {
                  this.refresh()
                }
                this.$emit('refresh')
                this.$message.info(this.$t('page_workstation_maintain_inport_success'))
              }
            }

          } else { // 旧返回形式：返回成功数，错误数
            if (this.refresh) {
              this.refresh()
            }
            this.$emit('refresh')
            let { uploadTotal, successUploadRecords, failUploadRecords } = res.data.data.productExportResult
            this.$message.info(
              this.$t('page_upload_info')
                .replace('{0}', uploadTotal)
                .replace('{1}', successUploadRecords)
                .replace('{2}', failUploadRecords)
            )
          }
        }

        this.visible = false
      } finally {
        this.loading.submit = false
      }
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file]
      return false
    }
  }
})
